import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
})
export class ResetPasswordComponent implements OnInit {
  loading = false;
  result: any;

  forgotPasswordForm: FormGroup = this.fb.group({
    password: ['', Validators.required],
    passwordVerify: ['', Validators.required],
  });


  get passwordsEqual() {
    if (this.forgotPasswordForm.get('password').value === this.forgotPasswordForm.get('passwordVerify').value) {
      return true;
    } else {
      return false;
    }
  }

  constructor(private auth: AuthService, private route: ActivatedRoute, private fb: FormBuilder) { }

  ngOnInit() { }

  async resetPassword(val: any) {
    this.loading = true;
    this.result = await this.auth
      .resetPassword(this.route.snapshot.queryParams.token, this.route.snapshot.queryParams.uid, val)
      .toPromise();
    this.loading = false;
  }
}
